import { ImportWorkspace } from "../import-workspace";

const FoodicsInventoryPage = () => <ImportWorkspace mode="inventory" />;

export default FoodicsInventoryPage;
